/**
 * Stored post bodies wrap Quill HTML with preview styles and .post-preview.
 * These helpers keep that format consistent between PostEditor and AI restructure.
 */

const POST_PREVIEW_STYLES = `
    <link href="https://fonts.googleapis.com/css2?family=Merriweather+Sans:wght@300;400;500&display=swap" rel="stylesheet">
    <style>
      .post-preview * {
        margin: 0;
        padding: 0;
      }
      .post-preview h1, .post-preview h2 {
        font-family: "Playfair Display", serif;
        color: #000;
        margin-top: 1.5rem;
        margin-bottom: 0.5rem;
      }

      .post-preview h1 {
        font-size: 22px;
      }

      .post-preview h2 {
        font-size: 18px;
      }

      .post-preview p {
        font-family: "Merriweather Sans", sans-serif;
        font-size: 15px;
        line-height: 1.6;
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
        color: #333;
        font-weight: 100 !important;
      }

      .post-preview ul, .post-preview ol {
        font-family: "Merriweather Sans", sans-serif;
        font-size: 15px;
        line-height: 1.6;
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
        padding-left: 1.5rem;
        list-style-position: outside;
        font-weight: 100 !important;
      }

      .post-preview ul {
        list-style-type: disc;
      }

      .post-preview ol {
        list-style-type: decimal;
      }

      .post-preview li {
        margin-bottom: 0.25rem;
      }
    </style>
  `;

export function stripPostPreviewHtml(stored) {
  if (!stored || typeof stored !== "string") return "";
  try {
    const doc = new DOMParser().parseFromString(stored, "text/html");
    const el = doc.querySelector(".post-preview");
    if (el) return el.innerHTML;
  } catch {
    // fall through
  }
  return stored;
}

export function wrapPostPreviewHtml(innerHtml) {
  return `${POST_PREVIEW_STYLES}<div class="post-preview">${innerHtml}</div>`;
}
